












































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import OrderTotals from "@/components/OrderTotals.vue";
import {DealersEntity} from "@/entity/DealersEntity";
interface userPermissionType{
    user_permission_type_id:number,
    name:string
}
interface userPermissions{
    "user_permission_id": "1",
    "dealer_id": null,
    "page": "Categories",
    "get": "0",
    "post": "0",
    "patch": "0",
    "delete": "0",
    "copy": "0",
    "created_at": null,
    "updated_at": null
}
@Component({
    components: {
        OrderTotals,
        DeleteButton,EForm,Id,EnabledSwitch,Number,TextField,Select35
    }
})
export default class Dealers extends  Vue{
    items : DealersEntity[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.Dealer;
    brokenAdminId:number = 3;
    action:string = this.baseAction;
    userPermissionAction:string = "userPermission";
    data : DealersEntity = new DealersEntity();
    userPermissionTypes : userPermissionType[] = []
    userOrderTotals!:any;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "id"
        },
        {text: "Kullanıcı Adı", value: "username"},
        {text: "Ad", value: "name"},
        {text: "Soyad", value: "lastname"},
        {text: "E-Posta", value: "email"},
        {text: "Oluşturulma", value: "created_at"},
        {text: "İşlemler", value: "actions"}
    ];
    permissionHeaders = [
        {text: "Sayfa", value: "page"},
        {text: "Gösterme", value: "get"},
        {text: "Ekleme / Düzenleme", value: "post"},
        {text: "Değiştirme", value: "patch"},
        {text: "Silme", value: "delete"},
        {text: "Kopyalama", value: "copy"},
    ]
    permissionItems : userPermissions[] = [];
    permissionSearch : string = "";
    async getUserPermissions(userId:number){
        let response =  await this.$http.post(this.userPermissionAction+"/"+userId);
        this.permissionItems = response.data;
    }
    async getUserOrderTotals(){
        let request = {
            status: 0,
            status_condition:"!=",
            user_id:this.data.id,
            all_dates:true
        }
        let response = await Vue.prototype.$http.request({
            method:"POST",
            responseType:"json",
            data:JSON.stringify(request),
            transformRequest:[function (data:any, headers:any) {
                return data;
            }],
            url:"report"
        });
        this.userOrderTotals = response.data;
    }
    async edit(item:DealersEntity){
        await this.getUserOrderTotals();
        await this.changePermissionType();
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.id;
        this.dialog = true;
    }
    async changePermissionType(){
        //console.log(this.data.user_permission_type_id);
        if(this.data.user_permission_type_id == this.brokenAdminId){ //Kısıtlı admin 3
            if(this.data.id == 0){
                alert("Lütfen önce üyeyi ekleyiniz yetki işlemlerini daha sonra tamamlayınız.");
                return;
            }
            this.getUserPermissions(this.data.id);
        }
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new DealersEntity();
        this.dialog = true;
    }
    async getUserPermissionTypes(){
        let response = await this.$http.get("userPermissionTypes");
        this.userPermissionTypes = response.data;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
        this.getUserPermissionTypes();
    }
};
